import React, { FC } from 'react'
import _ from 'lodash'
import { RentHover_s } from 'components/table/hovers/hover-styles'
import { localizeNum, isValidNumber } from "data/lib/numbers"
import { Label_s } from 'styles/app-styles'

type BasicHoverProps = {
  config: {},
  data: [],
  inflationData: object[]
}

const RentBasicHover: FC<BasicHoverProps> = (props) => {
  const row1 = props.config['basic'][0];
  const row2 = props.config['basic'][1];

  function returnRow(config):FC {
    return config.map((c) => {
      const label = c.label || null
      let   val   = null
      if (Array.isArray(c.key)){
        for (let i of c.key){
          val = val ? val[i] : props.data[i]
        }
      } else val = props.data[c.key]
      if (c.key[c.key.length - 1].endsWith('InflationNamedItemId') && val){
        val = _.find(props.inflationData, { inflationid: val }).code;
      }

      return (
        <div>
          { label && <Label_s>{ label }</Label_s> }
          { val && <span>{isValidNumber(val) ? localizeNum(val, 2) : val }
          </span> }
        </div>
      )
    })
  }
  
  return (
    <RentHover_s>
      <div>
        <Label_s>Occupied:</Label_s>
        <Label_s>Market:</Label_s>
      </div>
      <div>
        <div>
          <Label_s>Amount</Label_s>
          <Label_s>Amt Type</Label_s>
          <Label_s>Inflation</Label_s>
        </div>
        <div>{ returnRow(row1) }</div>
        <div>{ returnRow(row2) }</div>
      </div>
    </RentHover_s>
  )
}

export default RentBasicHover